import React from "react";
import { Link } from "react-router-dom"
import { auth, firestore } from "../config/firebase";
import { Button, Divider, Form, Input, message } from "antd";
import Title from "antd/es/typography/Title";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { useState } from "react";
const inputStyle = {
    border: 'none',
    borderBottom: '2px solid #fffa8a',
    outline: 'none',
    boxShadow: 'none',
    color: '#fffa8a',
    background: "transparent"
};
export default function SignUp({ handleSignupSuccess }) {
    const [isProcessing, setIsProcessing] = useState(false)
    const [state, setState] = useState({ email: "", password: "", fullName: "", fatherName: "", gender: "", country: "", phoneNumber: "", whatsappNumber: "" })
    const handleChange = (e) => setState({ ...state, [e.target.name]: e.target.value })
    const handleSignUp = async (e) => {
        e.preventDefault();
        setIsProcessing(true);

        try {
            const { email, password, fullName, fatherName, gender, country, phoneNumber, whatsappNumber } = state;

            if (!email || !password || !fullName || !fatherName || !gender || !country || !phoneNumber || !whatsappNumber) 
                return message.error("Fill all inputs");
     

            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // Call createUser function with user object (assuming this function exists)
            createUser(user);

            // Call handleSignupSuccess function (assuming this function exists)
            handleSignupSuccess();
        } catch (error) {
            console.error("Error during sign-up:", error.message);
            message.error("Some problem occurred during sign-up");
        } finally {
            setIsProcessing(false);
        }
    };

    const createUser = async (user) => {
        let { email, uid } = user
        let { fullName, fatherName, gender, country, phoneNumber, whatsappNumber } = state
        let userData = {
            email, uid, fullName, fatherName, gender, country, phoneNumber, whatsappNumber,
            dateCreated: serverTimestamp(), status: "active",
            role: "student",
        }
        try {
            await setDoc(doc(firestore, "users", uid), userData);
            message.success("A new user has been created successfully")
        } catch (e) {
            message.error("Something went wrong while creating user profile")
            console.error("Error adding document: ", e);
        }
    }
    return (
        <>
            <main className='auth p-8 sm:p-8 md:p-12'>

                <div className="card p-8 md:p-12 w-80 md:w-2/4 sm:w-72 rounded-xl" style={{ border: " 1px solid #fffa8a" }}>

                    <Title level={2} className='m-0 text-center' style={{ color: "#fffa8a" }}>Register/SignUp</Title>
                    <Divider style={{ backgroundColor: "gold" }} />

                    <Form layout="vertical">
                        <Form.Item label="Full Name" >
                            <Input name='fullName' style={inputStyle} onChange={handleChange} />
                        </Form.Item>
                        <Form.Item label="Father Name" >
                            <Input name='fatherName' style={inputStyle} onChange={handleChange} />
                        </Form.Item>
                        <Form.Item label="Phone number with country code" >
                            <Input name='phoneNumber' style={inputStyle} onChange={handleChange} />
                        </Form.Item>
                        <Form.Item label="Whatsapp number with country code" >
                            <Input name='whatsappNumber' style={inputStyle} onChange={handleChange} />
                        </Form.Item>
                        <Form.Item label="Gender" >
                            <Input name='gender' style={inputStyle} onChange={handleChange} />
                        </Form.Item>
                        <Form.Item label="Country" >
                            <Input name='country' style={inputStyle} onChange={handleChange} />
                        </Form.Item>
                        <Form.Item label="Email" >
                            <Input name='email' style={inputStyle} onChange={handleChange} />
                        </Form.Item>
                        <Form.Item label="Password" >
                            <Input type="password" style={inputStyle} name='password' onChange={handleChange} />
                        </Form.Item >
                        <div className="flex justify-content-center">
                            <Button htmlType='submit' className='px-10  mx-auto text-center rounded-2xl hover:rounded-lg ' style={{ background: "transparent", border: " 1px solid #fffa8a", color: "#fffa8a" }} loading={isProcessing}
                                onClick={handleSignUp}
                            >
                                Sign Up</Button>
                        </div>
                        <Form.Item label="Already have a account?" >
                            <Link to="/auth/login" style={{ color: "#fffa8a" }} >
                                <p className="text-3xl underline-offset-2 hover:text-[gold]" >Login !</p>
                            </Link>
                        </Form.Item>
                    </Form>
                </div>

            </main>
        </>

    );
}
